import { Component, OnInit, AfterContentInit, Input, ContentChildren, QueryList, Renderer2, ElementRef } from '@angular/core';
import { encapsulation } from '../encapsulation';
import { UBXTrackComponent } from './track/track.component';
import { Splitter } from '../../models';

@Component({
    selector: 'ubx-grid',
    templateUrl: './grid.component.html',
    host: { class: 'grd' },
    encapsulation
})
export class UBXGridComponent implements OnInit, AfterContentInit {
    @Input() columns: string;
    @Input() rows: string;

    @Input() gap: string;
    @Input() xGap: string;
    @Input() yGap: string;

    @Input() jc: string;
    @Input() ji: string;
    @Input() ac: string;
    @Input() ai: string;

    @ContentChildren(UBXTrackComponent) tracks: QueryList<UBXTrackComponent>;

    split: Splitter = new Splitter();

    constructor(
        private renderer: Renderer2,
        private el: ElementRef,
    ) { }

    ngOnInit() {
        this.setColumns(this.columns);
        this.setRows(this.rows);

        this.setGaps(this.gap, '');
        this.setGaps(this.xGap, 'x');
        this.setGaps(this.yGap, 'y');

        this.setAlign(this.jc, 'jc');
        this.setAlign(this.ji, 'ji');
        this.setAlign(this.ac, 'ac');
        this.setAlign(this.ai, 'ai');
    }

    ngAfterContentInit() {
        this.setColTracks(this.columns);
        this.setRowTracks(this.rows);

        this.tracks.changes.subscribe(() => {
            this.setColTracks(this.columns);
            this.setRowTracks(this.rows);
        });
    }

    private setColumns(columns: string | number) {
        return columns && this.split.splitter((columns), split => {
            let cols: string | number;
            if (split.value.indexOf('a') > -1) {
                cols = split.value;
            } else {
                cols = split.value.split('-').map(Number).reduce((a: number, b: number) => a + b, 0);
            }
            this.appendClass(`g-tc:${cols + split.media}`);
        });
    }
    private setRows(rows: string | number) {
        return rows && this.split.splitter((rows), split => {
            const cols = split.value.split('-').map(Number).reduce((a: number, b: number) => a + b, 0);
            this.appendClass(`g-tr:${cols + split.media}`);
        });
    }
    private setGaps(gap: string, axis: string) {
        return gap && this.split.splitter((gap), split => {
            this.appendClass(`g-g:${axis + split.value + split.media}`);
        });
    }
    private setAlign(align: string, axis: string) {
        return align && this.split.splitter((align), split => {
            this.appendClass(`g-${axis}:${split.value + split.media}`);
        });
    }
    private setColTracks(columns: string | number) {
        this.tracks.forEach((track: UBXTrackComponent, i: number) => {
            if (track.colSpan) {
                track.setSpan(Direction.Column, track.colSpan);
            } else {
                this.setTracks(columns, track, i, Direction.Column);
            }
        });
    }
    private setRowTracks(rows: string | number) {
        this.tracks.forEach((track: UBXTrackComponent, i: number) => {
            if (track.rowSpan) {
                track.setSpan(Direction.Row, track.rowSpan);
            } else {
                this.setTracks(rows, track, i, Direction.Row);
            }
        });
    }
    private setTracks(values: string | number, track: UBXTrackComponent, i: number, direction: Direction) {
        this.split.splitter((values), split => {
            const cols = split.value.split('-').map(Number);
            if (cols.length > 1) {
                cols.findIndex((col: number, j: number) => {
                    if (i % cols.length === j) {
                        track.setTrack(direction, col, split.media);
                    }
                });
            } else {
                track.setTrack(direction, 1, split.media);
            }
        });
    }

    private appendClass(name: string | number) {
        this.renderer.addClass(this.el.nativeElement, String(name));
    }
}

enum Direction {
    Column = 'c',
    Row = 'r'
}
